module.exports = __webpack_public_path__ + "img/iracemapolis.6ca945d9.png";